import React from "react";
import {ReactComponent as CheckBtnIcon} from "assets/images/icon/checkBtnIcon.svg";

const CheckBox = ({id, className, checked, text}) => {
  return (
    <>
      <input
        type="checkbox"
        id={id}
        className={`inputCheck ${className}`}
        defaultChecked={checked}
      />
      <label className="inputCheckLabel fs-16 fw-5 d-flex a-center j-left pointer" htmlFor={id}>
        <CheckBtnIcon width={22} height={22} className="mr-5" />
        {text}
      </label>
    </>
  );
}

export default CheckBox;